import { AHIcon, Box, ListItem } from "arkh";
import { graphql, useFragment } from "react-relay";

import { WorkspaceSignalStoreItemContainer } from "./WorkspaceSignalStoreItemContainer";
import { WorkspaceSignalStoreListItem_Signal$key } from "./__generated__/WorkspaceSignalStoreListItem_Signal.graphql";
import { OrgTableTitle } from "../../OrgTable/OrgTable";
import { SignalOpenedByEmployeeButton } from "@/src/features/Signals/SignalOpenedByEmployeeButton";

export function WorkspaceSignalStoreListItem(props: {
  signal: WorkspaceSignalStoreListItem_Signal$key;
  isLast: boolean;
  openSignal(signalId: string, storeName: string, storeTimezone: string): void;
  openSignalOpenedBy: (
    signalId: string,
    storeName: string,
    storeTimezone: string
  ) => void;
  disabled?: boolean;
}) {
  const signal = useFragment(
    graphql`
      fragment WorkspaceSignalStoreListItem_Signal on Signal {
        id
        store {
          id
          name
          timezone
        }
        ...SignalOpenedByEmployeeButton_signal
      }
    `,
    props.signal
  );

  return (
    <ListItem
      disabled={props.disabled}
      isLast={props.isLast}
      onPress={() => {
        props.openSignal(signal.id, signal.store.name, signal.store.timezone);
      }}
      displayMode="TABLE"
      border="border-primary"
    >
      <WorkspaceSignalStoreItemContainer
        storeName={
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <AHIcon type="store" color="text-washed" spaceRight="small" />
            <OrgTableTitle>{signal.store.name}</OrgTableTitle>
          </Box>
        }
        seen={
          <Box
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <SignalOpenedByEmployeeButton
              onPress={() =>
                props.openSignalOpenedBy(
                  signal.id,
                  signal.store.name,
                  signal.store.timezone
                )
              }
              signal={signal}
            />
            {props.disabled ? null : <ListItem.NavArrow />}
          </Box>
        }
      />
    </ListItem>
  );
}
